/**
 * This is a helper function that delays the render of a component
 * 
 * We use this to add animation effects to render
 * 
 * This is how you use it
 * 
 *  
 * import Delayed from '../Time/Delayed';
 * import React from 'react';

 * const myComp = props => (
 *    <DelayedRender waitBeforeShow={500}>
 *        <div>Some child</div>
 *    </DelayedRender>
 * )
 */

import React, { useState, useEffect } from 'react';

const Delayed = ({ children, waitBeforeShow = 500 }) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsShown(true);
    }, waitBeforeShow);
  }, [waitBeforeShow]);

  return isShown ? children : null;
};

export default Delayed;